<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer" @click="toogleIcon" @contextmenu.prevent="toogleView">
    <v-layout row wrap>
      <v-flex xs1 pa-0 style="display: flex; justify-content: center;">
        <v-icon v-bind:class="{ blue_icon: isSelected, grey_icon: !isSelected }">{{icon}}</v-icon>
      </v-flex>
      <v-flex xs11 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs8>
              <v-layout row wrap body-1>
                <v-flex xs12 py-0>
                  {{record.receiver_company_name}}
                </v-flex>
                <v-flex xs12 py-0>
                  Valor: {{l(record.exchanged_value, record.exchange_currency)}}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4 py-0 text-xs-right>
              <v-layout row wrap caption>
                <v-flex xs12 py-0 style="padding-top: 20px!important;">
                  {{record.currency}}
                  <v-icon class="arrow-icon-small">arrow_forward</v-icon>
                  {{record.exchange_currency}}
                </v-flex>
                <v-flex xs12 py-0>
                  {{humanMovementDate}}
                </v-flex>
              </v-layout>
            </v-flex>

            <transition name="fade">
              <v-flex xs12 v-if="current_view === 'detailed'">
                <v-layout row wrap body-1>
                  <v-flex xs12 py-0>
                    {{record.source_name}} {{record.source_document_type.toUpperCase()}}: {{record.source_document_number}}
                  </v-flex>
                  <v-flex xs12 py-0>
                    Banco {{record.source_bank}} Agência {{record.source_branch}} Conta {{record.source_account}}
                  </v-flex>
                  <v-flex xs12 py-0>
                    Origem {{record.source}} ID {{record.source_type}}-{{record.source_id}}
                  </v-flex>
                </v-layout>
              </v-flex>
            </transition>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider />
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"

export default {
  name: 'WireTransactionItem',
  props: {
    record: {
      type: Object
    }
  },
  data() {
    return {
      icon: 'check_box',
      selected: true,
      current_view: 'short'
    }
  },
  computed: {
    isSelected() {
      return this.selected
    },
    humanMovementDate() {
      return utils.dbDateToHuman(this.record.movement_date)
    }
  },
  methods: {
    toogleIcon() {
      this.$set(this, 'selected', !this.selected)
      this.$set(this.record, 'selected', this.selected)
      this.$set(this, 'icon', (this.selected ? 'check_box' : 'check_box_outline_blank'))
    },
    toogleView() {
      this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
    },
    l(number_value, currency) {
      return utils.currencyToLocal(number_value, currency)
    }
  },
  mounted() {
    if (typeof(this.record.selected) === 'undefined') {
      this.$set(this.record, 'selected', true)
    }
    this.$set(this, 'selected', this.record.selected)
    this.$set(this, 'icon', (this.selected ? 'check_box' : 'check_box_outline_blank'))
  }
}
</script>
<style>
  .v-icon.blue_icon {
    color: #37517e;
  }
  .v-icon.grey_icon {
    color: #CCC;
  }
</style>



// WEBPACK FOOTER //
// src/WireTransactionItem.vue